export default __webpack_public_path__ + "static/media/stove-icon.0d7429e6.svg";